import { RestService } from "./RestService";

export class LayoutRestService extends RestService {
  constructor() {
    super("api/v1/layouts");
  }
}
